export const imageServiceBaseUrl = {
  develop: 'https://il.srgssr.ch/images/',
  test: 'https://il-test.srgssr.ch/images/',
  stage: 'https://il-stage.srgssr.ch/images/',
  production: 'https://il.srgssr.ch/images/'
};